import { Button, ButtonProps } from '@zeus/core';

type OmitButtonKeys = 'size';
export interface StyledButtonProps extends Omit<ButtonProps, OmitButtonKeys> {}

export const StyledButton: React.FC<StyledButtonProps> = (props) => (
  <Button {...props} size="large" />
);
